const API_ENDPOINTS = {
  local: 'http://localhost:3040/api/v1',
  development: 'https://api-dev.xpressdocs.com/api/v1',
  production: 'https://api.xpressdocs.com/api/v1'
}

export const API_BASE_URL = API_ENDPOINTS[
  (process.env.REACT_APP_ENVIRONMENT || 'local') as keyof typeof API_ENDPOINTS
] || API_ENDPOINTS.local

export const API_CONFIG = {
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
}